module.exports = __webpack_public_path__ + "img/T1C_xs_004.1eb04b17.png";